import type { TranslationDict } from '../en';

const kn: TranslationDict = {
  'header.buy': 'ಖರೀದಿಸಿ',
  'header.sell': 'ಮಾರಿ',
  'spend.label': 'ನೀವು ಖರ್ಚು ಮಾಡುತ್ತೀರಿ',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'ನಿಮಗೆ ಸಿಗುತ್ತದೆ',
  'payment.label': 'ಪಾವತಿ ವಿಧಾನ',
  'payment.select': 'ಆಯ್ಕೆ ಮಾಡಿ',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'ಈ ಜೋಡಿಗೆ ಯಾವುದೇ ಪಾವತಿ ವಿಧಾನ ಲಭ್ಯವಿಲ್ಲ',
  'wallet.label': 'ಸ್ವೀಕರಿಸುವ ವಾಲೆಟ್ ವಿಳಾಸ',
  'wallet.placeholderBuy': 'ನಿಮ್ಮ ಸ್ವೀಕರಿಸುವ ವಿಳಾಸ ನಮೂದಿಸಿ',
  'wallet.placeholderSell': 'ನಿಮ್ಮ ಕಳುಹಿಸುವ ವಿಳಾಸ ನಮೂದಿಸಿ',
  'wallet.validating': 'ವಿಳಾಸ ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ...',
  'wallet.invalid': 'ಮಾನ್ಯ ವಾಲೆಟ್ ವಿಳಾಸ ನಮೂದಿಸಿ',
  'wallet.invalidServer': 'ಅಮಾನ್ಯ ವಾಲೆಟ್ ವಿಳಾಸ',
  'cta.buy': '{crypto} ಖರೀದಿಸಿ',
  'cta.sell': '{crypto} ಮಾರಿ',
  'cta.gettingPrice': 'ಅತ್ಯುತ್ತಮ ಬೆಲೆ ಪಡೆಯಲಾಗುತ್ತಿದೆ...',
  'cta.processing': 'ಪ್ರಕ್ರಿಯೆ ನಡೆಯುತ್ತಿದೆ...',
  'footer.poweredBy': 'ಇವರಿಂದ ಚಾಲಿತ ',
  'footer.brand': 'NowRamp',
  'rate.title': 'ದರ ವಿವರ',
  'rate.close': 'ಮುಚ್ಚಿ',
  'rate.updatesIn': 'ದರ 00:{seconds} ನಲ್ಲಿ ನವೀಕರಣಗೊಳ್ಳುತ್ತದೆ',
  'rate.noQuote': 'ಯಾವುದೇ ಉದ್ಧರಣ ಲಭ್ಯವಿಲ್ಲ',
  'rate.exchangeRate': 'ವಿನಿಮಯ ದರ',
  'rate.processingFee': 'ಪ್ರಕ್ರಿಯೆ ಶುಲ್ಕ',
  'rate.networkFee': 'ನೆಟ್‌ವರ್ಕ್ ಶುಲ್ಕ',
  'rate.provider': 'ಸೇವಾ ಪೂರೈಕೆದಾರ',
  'toast.orderCreated': 'ಆರ್ಡರ್ ರಚಿಸಲಾಗಿದೆ',
  'toast.redirecting': 'ಚೆಕ್‌ಔಟ್‌ಗೆ ಮರುನಿರ್ದೇಶಿಸಲಾಗುತ್ತಿದೆ...',
  'toast.orderFailed': 'ಆರ್ಡರ್ ವಿಫಲವಾಗಿದೆ',
  'toast.couldNotCreate': 'ಆರ್ಡರ್ ರಚಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ',
  'toast.quoteError': 'ಉದ್ಧರಣ ದೋಷ',
  'toast.noProviders': 'ಯಾವುದೇ ಪೂರೈಕೆದಾರರಿಲ್ಲ',
  'toast.somethingWrong': 'ಏನೋ ತಪ್ಪಾಗಿದೆ',
  'error.amountZero': 'ಮೊತ್ತ 0 ಕ್ಕಿಂತ ಹೆಚ್ಚಿರಬೇಕು',
  'error.minAmountFiat': 'ಕನಿಷ್ಠ ಮೊತ್ತ {min} {currency} ಆಗಿದೆ',
  'error.minAmountCrypto': 'ಕನಿಷ್ಠ ಮೊತ್ತ {min} {currency} ಆಗಿದೆ',
  'error.noProviders': 'ಈ ಸಂಯೋಜನೆಗೆ ಯಾವುದೇ ಪೂರೈಕೆದಾರರು ಲಭ್ಯವಿಲ್ಲ',
  'error.currencyUnavailableBuy': 'ಈ ಕರೆನ್ಸಿ ಖರೀದಿ ಆರ್ಡರ್‌ಗೆ ಲಭ್ಯವಿಲ್ಲ',
  'error.currencyUnavailableSell': 'ಈ ಕರೆನ್ಸಿ ಮಾರಾಟ ಆರ್ಡರ್‌ಗೆ ಲಭ್ಯವಿಲ್ಲ',
  'parity.info': 'ನಿಮ್ಮಿಂದ {receiveAmount} {crypto} ಗೆ ಶುಲ್ಕ ವಿಧಿಸಲಾಗುತ್ತದೆ, ಉಳಿದ {spendAmount} {fiat} ವರೆಗಿನ ಮೊತ್ತ ನಿಮ್ಮ {partner} ಖಾತೆಗೆ ಜಮಾ ಆಗುತ್ತದೆ',
  'redirect.secureBadge': 'ಸುರಕ್ಷಿತ ಪಾವತಿ',
  'redirect.title': 'ಪಾವತಿ ಮುಂದುವರಿಸಿ',
  'redirect.description': 'ನಿಮ್ಮ ಪಾವತಿ ಪೂರ್ಣಗೊಳಿಸಲು ನಿಮ್ಮನ್ನು {gateway} ಗೆ ಮರುನಿರ್ದೇಶಿಸಲಾಗುತ್ತದೆ.',
  'redirect.countdown': '{seconds} ನಲ್ಲಿ ಮರುನಿರ್ದೇಶಿಸಲಾಗುತ್ತಿದೆ...',
  'redirect.openTab': 'ಹೊಸ ಟ್ಯಾಬ್‌ನಲ್ಲಿ ACH ತೆರೆಯಿರಿ',
  'redirect.cancel': 'ರದ್ದು ಮಾಡಿ',
  'checkout.noOrder': 'ಯಾವುದೇ ಆರ್ಡರ್ ಕಂಡುಬಂದಿಲ್ಲ',
  'checkout.goBack': 'ಹಿಂತಿರುಗಿ',
  'checkout.expired': 'ಚೆಕ್‌ಔಟ್ ಅವಧಿ ಮೀರಿದೆ',
  'checkout.expiredDesc': 'ಸೆಷನ್ ಅವಧಿ ಮೀರಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  'checkout.startOver': 'ಮತ್ತೆ ಪ್ರಾರಂಭಿಸಿ',
  'checkout.cancel': 'ರದ್ದು ಮಾಡಿ',
  'checkout.loading': 'ಚೆಕ್‌ಔಟ್ ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
  'checkout.iframeTitle': 'ಪೂರೈಕೆದಾರ ಚೆಕ್‌ಔಟ್',
  'checkout.widgetTitle': 'ಪಾವತಿ ಚೆಕ್‌ಔಟ್',
  'checkout.unknownMethod': 'ಅಜ್ಞಾತ ಚೆಕ್‌ಔಟ್ ವಿಧಾನ',
  'processing.default': 'ನಿಮ್ಮ ಆರ್ಡರ್ ಪ್ರಕ್ರಿಯೆ ನಡೆಯುತ್ತಿದೆ...',
  'processing.pending': 'ಪಾವತಿ ದೃಢೀಕರಣಕ್ಕಾಗಿ ಕಾಯುತ್ತಿದ್ದೇವೆ...',
  'processing.active': 'ನಿಮ್ಮ ವ್ಯವಹಾರ ಪ್ರಕ್ರಿಯೆ ನಡೆಯುತ್ತಿದೆ...',
  'processing.generic': 'ಪ್ರಕ್ರಿಯೆ ನಡೆಯುತ್ತಿದೆ...',
  'processing.checkingStatus': 'ಸ್ಥಿತಿ ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ...',
  'processing.orderId': 'ಆರ್ಡರ್ ID',
  'processing.provider': 'ಸೇವಾ ಪೂರೈಕೆದಾರ',
  'processing.amount': 'ಮೊತ್ತ',
  'processing.receiving': 'ಸ್ವೀಕರಿಸಲಾಗುತ್ತಿದೆ',
  'processing.network': 'ನೆಟ್‌ವರ್ಕ್',
  'processing.toAddress': 'ಗಮ್ಯಸ್ಥಾನ ವಿಳಾಸ',
  'processing.usuallyMinutes': 'ಇದು ಸಾಮಾನ್ಯವಾಗಿ ಕೆಲವು ನಿಮಿಷಗಳನ್ನು ತೆಗೆದುಕೊಳ್ಳುತ್ತದೆ.',
  'processing.safeToClose': 'ನೀವು ಈ ಪುಟವನ್ನು ಸುರಕ್ಷಿತವಾಗಿ ಮುಚ್ಚಬಹುದು - ಪೂರ್ಣವಾದಾಗ ನಾವು ನಿಮಗೆ ಇಮೇಲ್ ಕಳುಹಿಸುತ್ತೇವೆ.',
  'complete.buyTitle': 'ಖರೀದಿ ಪೂರ್ಣ!',
  'complete.sellTitle': 'ಮಾರಾಟ ಪೂರ್ಣ!',
  'complete.buyDesc': 'ನಿಮ್ಮ {crypto} ನಿಮ್ಮ ವಾಲೆಟ್‌ಗೆ ಕಳುಹಿಸಲಾಗಿದೆ.',
  'complete.sellDesc': 'ನಿಮ್ಮ {fiat} ಪಾವತಿ ಪ್ರಕ್ರಿಯೆ ನಡೆಯುತ್ತಿದೆ.',
  'complete.amountBuy': 'ಸ್ವೀಕರಿಸಿದ ಮೊತ್ತ',
  'complete.amountSell': 'ಮಾರಿದ ಮೊತ್ತ',
  'complete.paidBuy': 'ಪಾವತಿಸಿದ ಮೊತ್ತ',
  'complete.paidSell': 'ಪಾವತಿ ಮೊತ್ತ',
  'complete.network': 'ನೆಟ್‌ವರ್ಕ್',
  'complete.wallet': 'ವಾಲೆಟ್',
  'complete.transaction': 'ವ್ಯವಹಾರ',
  'complete.provider': 'ಸೇವಾ ಪೂರೈಕೆದಾರ',
  'complete.orderId': 'ಆರ್ಡರ್ ID',
  'complete.completed': 'ಪೂರ್ಣ',
  'complete.viewExplorer': 'ಎಕ್ಸ್‌ಪ್ಲೋರರ್‌ನಲ್ಲಿ ವೀಕ್ಷಿಸಿ',
  'complete.done': 'ಮುಗಿಯಿತು',
  'errorStep.failed': 'ಪಾವತಿ ವಿಫಲ',
  'errorStep.cancelled': 'ಆರ್ಡರ್ ರದ್ದಾಗಿದೆ',
  'errorStep.expired': 'ಆರ್ಡರ್ ಅವಧಿ ಮೀರಿದೆ',
  'errorStep.refunded': 'ಆರ್ಡರ್ ಹಿಂತಿರುಗಿಸಲಾಗಿದೆ',
  'errorStep.unknown': 'ಏನೋ ತಪ್ಪಾಗಿದೆ',
  'errorStep.failedBuy': 'ನಿಮ್ಮ ಪಾವತಿ ಪ್ರಕ್ರಿಯೆ ಆಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಬೇರೆ ಪಾವತಿ ವಿಧಾನ ಬಳಸಿ.',
  'errorStep.failedSell': 'ನಿಮ್ಮ ಮಾರಾಟ ಪ್ರಕ್ರಿಯೆ ಆಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  'errorStep.cancelledBuy': 'ನಿಮ್ಮ ಆರ್ಡರ್ ರದ್ದಾಗಿದೆ. ಯಾವುದೇ ಪಾವತಿ ಪ್ರಕ್ರಿಯೆ ಆಗಿಲ್ಲ.',
  'errorStep.cancelledSell': 'ನಿಮ್ಮ ಮಾರಾಟ ರದ್ದಾಗಿದೆ. ಯಾವುದೇ ಕ್ರಿಪ್ಟೋ ವರ್ಗಾಯಿಸಲಾಗಿಲ್ಲ.',
  'errorStep.expiredBuy': 'ನಿಮ್ಮ ಆರ್ಡರ್ ಅವಧಿ ಮೀರಿದೆ. ದಯವಿಟ್ಟು ಹೊಸ ಖರೀದಿ ಪ್ರಾರಂಭಿಸಿ.',
  'errorStep.expiredSell': 'ನಿಮ್ಮ ಆರ್ಡರ್ ಅವಧಿ ಮೀರಿದೆ. ದಯವಿಟ್ಟು ಹೊಸ ಮಾರಾಟ ಪ್ರಾರಂಭಿಸಿ.',
  'errorStep.refundedBuy': 'ನಿಮ್ಮ ಪಾವತಿ ಹಿಂತಿರುಗಿಸಲಾಗಿದೆ. 5-10 ಕೆಲಸದ ದಿನಗಳಲ್ಲಿ ಮೊತ್ತ ನಿಮ್ಮ ಖಾತೆಯಲ್ಲಿ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತದೆ.',
  'errorStep.refundedSell': 'ನಿಮ್ಮ ಕ್ರಿಪ್ಟೋ ಹಿಂತಿರುಗಿಸಲಾಗಿದೆ. ಶೀಘ್ರದಲ್ಲೇ ಮೊತ್ತ ನಿಮ್ಮ ವಾಲೆಟ್‌ನಲ್ಲಿ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತದೆ.',
  'errorStep.genericDesc': 'ಅನಿರೀಕ್ಷಿತ ದೋಷ ಸಂಭವಿಸಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  'errorStep.orderId': 'ಆರ್ಡರ್ ID',
  'errorStep.tryAgain': 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
  'errorStep.startOver': 'ಮತ್ತೆ ಪ್ರಾರಂಭಿಸಿ',
  'errorStep.return': 'ಹಿಂತಿರುಗಿ',
  'errorStep.needHelp': 'ಸಹಾಯ ಬೇಕೇ? ಸಂಪರ್ಕಿಸಿ ',
  'errorStep.reference': 'ಉಲ್ಲೇಖ: {orderId}',
  'confirm.buyTitle': 'ಖರೀದಿ ದೃಢಪಡಿಸಿ',
  'confirm.sellTitle': 'ಮಾರಾಟ ದೃಢಪಡಿಸಿ',
  'confirm.loading': 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
  'confirm.provider': 'ಸೇವಾ ಪೂರೈಕೆದಾರ',
  'confirm.youPay': 'ನೀವು ಪಾವತಿಸುತ್ತೀರಿ',
  'confirm.youSell': 'ನೀವು ಮಾರುತ್ತೀರಿ',
  'confirm.youReceive': 'ನಿಮಗೆ ಸಿಗುತ್ತದೆ',
  'confirm.wallet': 'ವಾಲೆಟ್',
  'confirm.network': 'ನೆಟ್‌ವರ್ಕ್',
  'confirm.refundAddress': 'ಹಿಂದಿರುಗಿಸುವ ವಿಳಾಸ',
  'confirm.parityNote': 'ಪೂರೈಕೆದಾರರಿಂದ ವಿಧಿಸಲಾದ ಮೊತ್ತ ಭಿನ್ನವಾಗಿರಬಹುದು. ಉಳಿದ {amount} {crypto} ವರೆಗಿನ ಮೊತ್ತ ನಿಮ್ಮ {partner} ಖಾತೆಗೆ ಜಮಾ ಆಗುತ್ತದೆ.',
  'confirm.processing': 'ಪ್ರಕ್ರಿಯೆ ನಡೆಯುತ್ತಿದೆ...',
  'confirm.confirmPay': 'ದೃಢಪಡಿಸಿ ಮತ್ತು ಪಾವತಿಸಿ',
  'confirm.confirmSell': 'ದೃಢಪಡಿಸಿ ಮತ್ತು ಮಾರಿ',
  'confirm.payout': '{currency} ಪಾವತಿ',
  'modal.selectFiat': 'ಫಿಯಾಟ್ ಕರೆನ್ಸಿ ಆಯ್ಕೆ ಮಾಡಿ',
  'modal.selectCrypto': 'ಕ್ರಿಪ್ಟೋ ಕರೆನ್ಸಿ ಆಯ್ಕೆ ಮಾಡಿ',
  'modal.choosePayment': 'ಪಾವತಿ ವಿಧಾನ ಆಯ್ಕೆ ಮಾಡಿ',
  'modal.selectCountry': 'ನಿಮ್ಮ ದೇಶ ಆಯ್ಕೆ ಮಾಡಿ',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'ಜನಪ್ರಿಯ',
  'modal.recommended': 'ಶಿಫಾರಸು ಮಾಡಲಾಗಿದೆ',
  'modal.noCurrencies': 'ಯಾವುದೇ ಕರೆನ್ಸಿ ಕಂಡುಬಂದಿಲ್ಲ',
  'modal.noPaymentMethods': 'ಯಾವುದೇ ಪಾವತಿ ವಿಧಾನ ಕಂಡುಬಂದಿಲ್ಲ',
  'modal.noCountries': 'ಯಾವುದೇ ದೇಶ ಕಂಡುಬಂದಿಲ್ಲ',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'ಸ್ಥಳ',
  'settings.darkMode': 'ಡಾರ್ಕ್ ಮೋಡ್',
  'settings.privacy': 'ಗೌಪ್ಯತಾ ನೀತಿ',
  'settings.terms': 'ಬಳಕೆಯ ನಿಯಮಗಳು',
  'settings.language': 'ಭಾಷೆ',

  // ─── Additional ───
  'modal.chooseRamp': 'Ramp ಆಯ್ಕೆ ಮಾಡಿ',
  'modal.bestPrice': 'ಅತ್ಯುತ್ತಮ ಬೆಲೆ',
  'modal.noQuotes': 'ಈ ವಿನಂತಿಗೆ ಯಾವುದೇ ಉದ್ಧರಣಗಳು ಲಭ್ಯವಿಲ್ಲ',
  'modal.noProvidersFound': 'ಯಾವುದೇ ಪೂರೈಕೆದಾರರು ಕಂಡುಬಂದಿಲ್ಲ',
  'payment.unavailableFor': '{currency} ಗೆ ಯಾವುದೇ ಪಾವತಿ ವಿಧಾನ ಲಭ್ಯವಿಲ್ಲ',
  'skeleton.poweredBy': 'NowRamp ಇವರಿಂದ ಚಾಲಿತ',
  'error.createOrderFailed': 'ಆರ್ಡರ್ ರಚಿಸಲು ವಿಫಲವಾಗಿದೆ',
  'errorStep.returnToMerchant': 'ವ್ಯಾಪಾರಿಗೆ ಹಿಂತಿರುಗಿ',
  'confirm.cryptoOnNetwork': '{crypto} {network} ಮೇಲೆ',
  'payment.name.card': 'ಕಾರ್ಡ್',
  'payment.name.bankTransfer': 'ಬ್ಯಾಂಕ್ ವರ್ಗಾವಣೆ',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default kn;
